import styled from "styled-components";
import { display, margin } from "styled-system";

export const StyledNavbarWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;

export const StyledNavbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 20px 30px;
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    justify-content: flex-start;
    padding: 25px 40px 30px ;
    margin: 0 auto;
  }
`;

export const StyledNav = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  transition: 0.5s;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 20px 20px;
  right: ${({ active }) => (active ? 0 : "-100vw")};
  background: rgba(20, 29, 42, 0.96);
  z-index: 3;
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    width: auto;
    height: auto;
    position: initial;
    flex-direction: row;
    background: none;
    padding: 0;
    margin-left: auto;
    align-items: center;
  }
`;

export const StyledHamburger = styled.button`
  background: none;
  position: relative;
  z-index: 11;
  ${display};
  cursor: pointer;
`;

export const StyledWorkWithUs = styled.button`
  background: none;
  font-style: normal;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: 1.5px solid #ffffff;
  box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.06);
  border-radius: 22px;
  padding: 11px 55px;
  text-align: center;
  box-sizing: border-box;
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-left: 65px;
    padding: 11px 26px;
  }
`;

export const StyledNavLink = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.white};
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  margin-bottom: 50px;
  cursor: pointer;
  
  &::before {
    content: "";
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${({ budgeColor }) => budgeColor};
    right: -5px;
    top: -5px;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin: 0 20px;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const HamburgerIcon = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 1.8px;
    width: 100%;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
  }
  
  span:nth-child(1) {
    top: ${({ active }) => (active ? "7px" : 0)};
    transform: ${({ active }) => (active ? "rotate(135deg)" : "none")};
  }
  
  span:nth-child(2) {
    top: 7px;
    opacity: ${({ active }) => (active ? "0" : 1)};
    left: ${({ active }) => (active ? "-60px" : 0)};
  }
  
  span:nth-child(3) {
    top: ${({ active }) => (active ? "7px" : "14px")};
    transform: ${({ active }) => (active ? "rotate(-135deg)" : "none")};
  }
`;
